import { Omit, SelectHelperMenuItem } from 'bold-ui'
import locale from 'bold-ui/lib/i18n/locales/pt-BR'
import { SelectFieldProps } from 'components/form'
import { DEFAULT_SELECT_SIZE } from 'components/form/field'
import { CidadaoSelectFieldItem } from 'components/form/field/select/CidadaoSelectField/CidadaoSelectFieldItem'
import { useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { CidadaoAtendimentoSelectFieldDocument } from 'graphql/hooks.generated'
import {
  CidadaoAtendimentoSelectFieldQuery,
  CidadaoAtendimentoSelectFieldQueryVariables,
} from 'graphql/types.generated'
import { useRouter } from 'hooks/useRouter'
import React from 'react'

import { SelectFieldWithAddButton } from '../../../final-form/SelectField/SelectFieldWithAddButton'

export interface CidadaoAtendimentoSelectFieldProps
  extends Omit<SelectFieldProps<CidadaoAtendimentoSelectFieldModel>, 'items' | 'itemToString'> {
  ativo?: boolean
  obito?: boolean
}

export type CidadaoAtendimentoSelectFieldModel = {
  id: string
  nome: string
  nomeSocial?: string
  cpf?: string
  cns?: string
  nomeMae?: string
  dataNascimento: any
  presenteListaAtendimento?: boolean
}

export function CidadaoAtendimentoSelectField(props: CidadaoAtendimentoSelectFieldProps) {
  const { history } = useRouter()
  const { ativo, obito, ...rest } = props

  const { skiping, ...asyncProps } = useAsyncQuerySelect<
    CidadaoAtendimentoSelectFieldModel,
    CidadaoAtendimentoSelectFieldQuery,
    CidadaoAtendimentoSelectFieldQueryVariables
  >({
    query: CidadaoAtendimentoSelectFieldDocument,
    extractItems: (data) => data && data.cidadaosCombo,
    variables: (inputString) => ({
      input: {
        query: inputString,
        ativo: ativo,
        obito: obito,
        limit: DEFAULT_SELECT_SIZE,
      },
    }),
    skip: (inputString) => inputString?.trim()?.length < 2,
    debounceTime: 500,
  })

  const isPresente = (cidadao: CidadaoAtendimentoSelectFieldModel) => cidadao.presenteListaAtendimento

  const itemToString = (item: CidadaoAtendimentoSelectFieldModel) => item?.nomeSocial || item?.nome

  const renderItem = (item: CidadaoAtendimentoSelectFieldModel) => {
    return item && <CidadaoSelectFieldItem item={item} />
  }

  const onClickCadastrarButton = () => {
    return history.push('/cidadao?callbackUrl=lista-atendimento')
  }

  return (
    <SelectFieldWithAddButton<CidadaoAtendimentoSelectFieldModel>
      itemToString={itemToString}
      renderItem={renderItem}
      itemIsEqual={isPresente}
      menuMinWidth={500}
      popperProps={{ modifiers: [{ name: 'preventOverflow', enabled: false }] }}
      addText='Cadastre um cidadão somente se não o encontrar na busca.'
      addButtonText='Cadastrar cidadão'
      onClickAddButton={onClickCadastrarButton}
      components={{
        EmptyItem: () => (
          <SelectHelperMenuItem>
            {skiping ? 'Digite para buscar um cidadão' : locale.select.emptyItem}
          </SelectHelperMenuItem>
        ),
      }}
      {...asyncProps}
      {...rest}
    />
  )
}
